<!-- src/app/time-attendance/yyww/pages/yyww/yyww.component.html -->

<planning-top-nav></planning-top-nav>

<div class="yyww-container">
    <!-- Loading -->
    <div *ngIf="isLoading" class="spinner-container">
        <div class="spinner"></div>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
    </div>

    <!-- Header -->
    <div class="header" *ngIf="!isLoading">
        <h2>YYWW</h2>
        <div class="header-actions">
            <button class="btn btn-primary" (click)="openCreateModal()">
                + Create Year
            </button>
        </div>
    </div>

    <!-- Filters -->
    <div class="filters-container" *ngIf="!isLoading">
        <div class="filters-row">
            <label class="filter-field search-field">
                <span>Search</span>
                <app-search-bar [value]="filters.searchTerm" [debounceMs]="600" placeholder="Search year or year/week"
                    (searchChange)="onSearchTermChange($event)">
                </app-search-bar>
            </label>
        </div>
    </div>

    <!-- Year List -->
    <div class="year-groups" *ngIf="!isLoading">
        <div *ngFor="let group of yearGroups; trackBy: trackByYear" class="year-card">
            <button type="button" class="year-header" (click)="toggleYear(group.year)">
                <div class="year-header-left">
                    <span class="expand-icon" [class.expanded]="group.isExpanded">›</span>

                    <div class="year-title-wrap">
                        <div class="year-title">{{ group.year }}</div>
                        <div class="year-subtitle">{{ group.weeks.length }} weeks</div>
                    </div>
                </div>

                <div class="year-actions">
                    <button type="button" class="btn delete" (click)="openDeleteModal(group.year, $event)">
                        Delete Year
                    </button>
                </div>
            </button>

            <div *ngIf="group.isExpanded" class="weeks-panel">
                <div *ngFor="let yyww of group.weeks; trackBy: trackByYywwId" class="week-row">
                    <div class="week-main">
                        <div class="week-code">{{ yyww.fullYearWeek }}</div>

                        <div class="week-meta">
                            <span>Week {{ yyww.week }}</span>
                            <span>{{ yyww.startDate }} - {{ yyww.endDate }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!isLoading && !errorMessage && yearGroups.length === 0">
        No YYWW years found.
    </div>

    <!-- Create Modal -->
    <div *ngIf="createModalOpen" class="modal-backdrop" (click)="closeCreateModal()">
        <div class="modal" (click)="$event.stopPropagation()">
            <h2>Create YYWW Year</h2>

            <form (ngSubmit)="submitCreate()">
                <label for="year">Year</label>
                <input id="year" type="text" name="year" maxlength="4" inputmode="numeric" pattern="[0-9]{4}"
                    [(ngModel)]="formModel.year"
                    (input)="formModel.year = $any($event.target).value.replace(/[^0-9]/g, '').slice(0,4)"
                    placeholder="YYYY" />

                <div class="modal-buttons">
                    <button type="button" class="btn btn-secondary" (click)="closeCreateModal()">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary">
                        Create
                    </button>
                </div>
            </form>
        </div>
    </div>

    <!-- Delete Modal -->
    <div *ngIf="deleteModalOpen" class="modal-backdrop" (click)="closeDeleteModal()">
        <div class="modal" (click)="$event.stopPropagation()">
            <h2>Delete YYWW Year</h2>

            <p class="modal-message">
                Are you sure you want to delete all YYWW records for
                <strong>{{ selectedYearForDelete }}</strong>?
            </p>

            <div class="modal-buttons">
                <button type="button" class="btn btn-secondary" (click)="closeDeleteModal()">
                    Cancel
                </button>
                <button type="button" class="btn delete" (click)="confirmDeleteYear()">
                    Delete
                </button>
            </div>
        </div>
    </div>

    <!-- Toast -->
    <div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
        <img class="icon" alt="icon" />
        <span>{{ toastMessage }}</span>
    </div>
</div>